<template>
  <nav class="navbar navbar-expand-lg border-0">
    <div class="container-fluid">
      <div class="cms">
        <img
          src="/static/img/logo-empresa-generico.png"
          alt="Logo SmartCultivo"
        />
        <a class="navbar-brand">{{ getNameCompany }}</a>
      </div>
      <em
        class="icon-user-top-navbar fa fa-user custom-color-navbar-brand custom-media-screem"
      ></em>
      <a class="custom-color-navbar-brand navbar-brand custom-media-screem"
        >{{ getUserName }} &nbsp;&nbsp;/&nbsp;&nbsp;
      </a>
      <a role="button" @click.prevent="signout" class="custom-media-screem">
        <em class="fa fa-power-off"></em> {{ $t('common_words.exit') }}
      </a>
      <button
        type="button"
        class="navbar-toggler navbar-toggler-right"
        :class="{ toggled: $sidebar.showSidebar }"
        aria-expanded="false"
        @click="toggleSidebar"
      >
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
      </button>
      <div
        class="collapse navbar-collapse justify-content-end position-relative"
      >
        <menu-translate />
        <div class="navbar-minimize">
          <button
            class="btn btn-outline btn-fill rounded-circle btn-icon d-none d-lg-block bg-white btn-min-per"
            @click="minimizeSidebar"
          >
            <em class="fa fa-ellipsis-v"></em>
          </button>
        </div>
        <el-image
          v-if="icon === '/static/img/Logo_Agroideo.svg'"
          :src="icon"
          style="width: auto; height: 110px"
        >
        </el-image>
        <div v-else class="custom-logo-business">
          <el-image :src="icon" />
        </div>
      </div>
    </div>
  </nav>
</template>
<script>
import { mapActions } from 'vuex';
import { Image } from 'element-ui';
import MenuTranslate from './MenuTranslate.vue';
import { DISK_URL } from 'src/util/Util';

export default {
  components: {
    MenuTranslate,
    [Image.name]: Image,
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    getUserName() {
      return this.capitalizeFirstLetter(
        this.$store.state.auth.user.first_name +
          ' ' +
          this.$store.state.auth.user.last_name
      );
    },
    getNameCompany() {
      return this.$store.state.auth.user.business[0].name;
    },
  },
  data() {
    return {
      activeNotifications: false,
      icon: '/static/img/smartcultivo_logo.png',
    };
  },
  methods: {
    // mapeamos las acciones de nuestro store para poder llamarlas desde este script
    ...mapActions({
      logout: 'auth/logout',
      cleanUserlogout: 'auth/cleanUserlogout',
    }),

    // llamamos a nuestra accion para limpiar el token, luego limpiamos el usuario
    signout() {
      this.$emit('dashLoading', true);
      sessionStorage.removeItem('urlModule');
      localStorage.removeItem('downtime');
      this.logout().then(() => {
        this.$router.push('/login');
        this.cleanUserlogout();
      });
    },

    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    minimizeSidebar() {
      let logo = document.getElementsByClassName('custom-logo-sidebar');
      if (!this.$sidebar.isMinimized) {
        logo[0].style.maxWidth = '58px';
      } else {
        logo[0].style.maxWidth = '110px';
      }
      this.$sidebar.toggleMinimize();
    },
  },
  created() {
    const businessWithIcon = this.$store.state.auth.user.business.find(
      (buss) => buss.icon != null && buss.id !== 1
    );

    if (
      businessWithIcon != null &&
      businessWithIcon.icon != 'Logo SmartCultivo.svg'
    ) {
      const iconPath = businessWithIcon.icon;
      this.icon = `${DISK_URL}business_logos/${iconPath}`;
    } else {
      this.icon = '/static/img/smartcultivo_logo.png';
    }
  },
};
</script>
<style scope>
.custom-logo-business {
  width: 210px;
  max-height: 115px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
</style>
